import { AppState } from "../../../redux-configuration/AppState";
import { Company } from "../../../company/domain/entity/company";

export const loadLocalBusinessLoadingSelector = (appState: AppState): boolean => appState.registration.loadLocalBusiness.loading
export const loadLocalBusinessErrorSelector = (appState: AppState): string | undefined => appState.registration.loadLocalBusiness.error
export const localBusinessSelector = (appState: AppState): Company | null => appState.registration.loadLocalBusiness.business
